export interface ISplitPaginationResult {
 pages: number[]
 showLeftDots: boolean
 showRightDots: boolean
}

export interface ISplitPaginationParams {
  currentPage: number
  pagesCount: number
  siblingsCount: number
}

export const splitPagination = ({
  currentPage,
  pagesCount,
  siblingsCount
}: ISplitPaginationParams): ISplitPaginationResult => {
 let pages = []

 if(pagesCount <= 5) {
  pages = Array.from({ length: pagesCount > 4 ? 5 : pagesCount }, (_v, i: number) => i + 1)
  return { pages, showLeftDots: false, showRightDots: false }
 }

 if(currentPage <= (siblingsCount + 1)) {
  pages = Array.from({ length: pagesCount > 4 ? 5 : pagesCount }, (_v, i: number) => i + 1)
  return { pages, showLeftDots: false, showRightDots: pagesCount > 5 }
 }

 if(currentPage > (pagesCount - (siblingsCount + 1))) {
  pages = [
    pagesCount - 4,
    pagesCount - 3,
    pagesCount - 2,
    pagesCount - 1,
    pagesCount
  ]

  return { 
    showLeftDots: pagesCount > 5,
    showRightDots: false,
    pages
  }
 }

 if(currentPage > (siblingsCount + 1)) {
  for (let i = (currentPage - siblingsCount); i <= (currentPage + siblingsCount); i++) {
    pages.push(i)
   }
  
   return {
    showLeftDots: true,
    showRightDots: true,
    pages: pages
   }
 }

 return { pages: [], showLeftDots: false, showRightDots: false }
}